'use strict';

/**
 *
 * @name: login
 *
 */

import DirectiveTemplate from './nn-login-modal.directive.html';

function LoginModalDirective(
  apiUserService,
  // registerFb,
  registerLi,
  registerTw,
  registerDb,
  registerWb,
  $location,
  $rootScope,
  angularticsService,
  userAnalytics,
  nnModalsService,
  $sessionStorage,
  $injector
) {

  'ngInject';

  var registerFb;
  if ($rootScope.lang !== 'zh-cn') {
      registerFb = $injector.get('registerFb');
  }

  return {
    restrict: 'E',
    replace: true,
    template: DirectiveTemplate,
    link: function(scope, element) {

      /*
       *
       * @CONFIG
       *
       */

      var rootWatchers = {};

      scope.showWechatCode = false;
      scope.userService = {
        comingFromSignup: false,
        saveProfile: function() {

          return apiUserService.saveProfile();
        },
        showNotificationsOnConfirmModal: false
      };
      scope.newSignUpSchema = {
        loginInt: false,
        facebookLoginInt: false,
        twitterLoginInt: false,
        linkedinLoginInt: false,
        weiboLoginInt: false,
        doubanLoginInt: false
      };
      scope.newSignUp = angular.copy(scope.newSignUpSchema);
      scope.settings = {

        remember: true
      };
      scope.recommended = [];
      scope.recommendedLimit = 5;
      scope.recommendedPage = 1;
      scope.location = $location;
      scope.route = {};
      scope.user = {};
      scope.password = {
        one: '',
        two: ''
      };
      scope.userOptions = {
        receiveDailyNewsletter: true,
        receiveWeeklyNewsletter: true,
        receiveOffers: false,
        isPublic: true
      };
      scope.analytics = userAnalytics;

      /*
       *
       * @PUBLIC
       *
       */

      scope.login = function() {

        apiUserService
          .getTokenAndUser(scope.user, scope.settings.remember)
          .then(function() {
            nnModalsService.hideModal('login')
          }, function(error) {

            $rootScope.errors.push(error);
          });
      };

      scope.registerForm = function() {

        angular.extend(scope.user, {
          source: 'form',
          roles: ['member'],
          password: scope.password.one,
          language: $rootScope.lang,
          receiveDailyNewsletter: scope.userOptions.receiveDailyNewsletter,
          receiveWeeklyNewsletter: scope.userOptions.receiveWeeklyNewsletter,
          receiveOffers: scope.userOptions.receiveOffers,
          isPublic: scope.userOptions.isPublic
        });

        apiUserService
          .register(scope.user, scope.settings.remember)
          .then(function() {

            apiUserService
              .getUser(scope.settings.remember)
              .then(function() {

                scope.route.signupModal = false;
                _getRecommended();
                $rootScope.notMyFirstTime = false;
                scope.route.confirmModal = true;
              });
          }, function(error) {

            if (error.code === 'ConflictError') {

              error.message = 'EMAIL_EXISTS';
            }

            $rootScope.errors.push(error);
          });
      };

      scope.doubanLogin = function(whereFrom) {

        return registerDb.login(whereFrom);
      };

      scope.sinaLogin = function(whereFrom) {

        return registerWb.login(whereFrom);
      };

      scope.qqLogin = function(){
        // var url = 'https://graph.qq.com/oauth/show?which=Login&display=pc&response_type=token&client_id=101425922&redirect_uri=' + window.location.origin + '/qq-redirect' + '&state=124';
        var url = 'https://graph.qq.com/oauth/show?which=Login&display=pc&response_type=token&client_id=101425922&redirect_uri=https://www.nowness.cn' + '/qq-redirect' + '&state=124';

        window.location.href = url;
      };

      scope.showWechat = function(){

        scope.showWechatCode = !scope.showWechatCode;

        setTimeout(function(){
          $('html, body').animate({
            scrollTop: element.find('[data-nn-wechat-qr-code]').offset().top - 600
          }, 1000);
        });
      };

      scope.linkedInLogin = (connectAccount) => {
        registerLi.getAccessToken({ rememberUser: scope.settings.remember, connectAccount })
      }

      scope.twitterLogin = function(whereFrom) {

        return registerTw.roar(whereFrom);
      };

      scope.loadMoreRecommended = function() {

        scope.recommendedPage++;

        if (scope.recommendedLimit === 5) {

          scope.recommendedLimit = Infinity;
        } else {

          apiUserService
            .listUsers(scope.recommendedPage, 24, ['contributor', 'member'], 'isRecommended desc,followersCount desc', false, false, false, $rootScope.profile.id)
            .then(function(res) {

              res.data.items.forEach(function(item) {

                scope.recommended.push(item);
              });
            });
        }
      };

      scope.removeFromList = function(index) {

        setTimeout(function() {

          scope.$apply(function() {

            scope.recommended.splice(index, 1);
          });
        }, 800);
      };

      scope.scrollMeToTheTopBaby = function() {

        $('body').animate({
          scrollTop: 0
        }, {
          queue: false
        });
      };

      scope.facebookLogin = function(connectAccount) {
        if(registerFb){
          if (connectAccount) {

            registerFb
              .getForMerge()
              .then(function(res) {

                apiUserService
                  .merge('facebook', res.authResponse.accessToken)
                  .then(function() {

                    apiUserService.getUser();
                  }, function(err) {

                    $rootScope.errors.push(err);
                  });
              }, function(err) {

                $rootScope.errors.push(err);
              });
          } else {

            registerFb
              .login(scope.settings.remember)
              .then(function(response) {

                void 0;
                void 0;
                if (connectAccount) {

                  // do nothing
                } else if (response[1] === 201) {
                  void 0;

                  if (!scope.userService.comingFromSignup) {

                    scope.userService.showNotificationsOnConfirmModal = true;
                  }
                  _getRecommended();
                  scope.route.signupModal = false;
                  scope.route.loginModal = false;
                  scope.route.confirmModal = true;
                  nnModalsService.showModal('confirm')
                } else {

                  nnModalsService.hideModal('login')
                }
              }, function(error) {

                $rootScope.errors.push(error);
              });
          }
        }
      };

      /*
       *
       * @PRIVATE
       *
       */

      function _getRecommended() {

        scope.recommendedPage = 1;

        apiUserService
          .listUsers(1, 24, ['contributor', 'member'], 'isRecommended desc,followersCount desc', false, false, false, $rootScope.profile.id)
          .then(function(res) {

            scope.recommendedTotalPages = res.data.meta.totalPages;

            res.data.items.forEach(function(item) {

              scope.recommended.push(item);
            });
          });

        rootWatchers.remindMe();
      }

      /*
       *
       * @INIT
       *
       */

      apiUserService.setRedirectAfterGettingUser({ to: '/profile/account-feed' })

      if ($sessionStorage && $sessionStorage.Nowness && $sessionStorage.Nowness.signUpFromLoginButton === 1) {

        scope.userService.showNotificationsOnConfirmModal = true;
        delete $sessionStorage.Nowness.signUpFromLoginButton;
      }

      rootWatchers.remindMe = $rootScope.$watch('remindMe', function() {

        if (scope.recommended.length === 0) {

          _getRecommended();
        }
      });

      setTimeout(function() {

        $('a#js-hamburger, a.js-toolbar__search, a.js-play-button-header')
          .on('click.userModal', function() {
            nnModalsService.hideModal(123456)
            $rootScope.$apply();
          });
      }, 500);

      scope.$watch('location.search()["modal"]', function(newVal) {

        var analyticsData;
        scope.newSignUp = angular.copy(scope.newSignUpSchema);

        if (newVal === 'login') {

          scope.route.loginModal = true;
          analyticsData = {
            pageID: 'NA',
            primaryCategory: 'customer account',
            subCategory1: 'authentication',
            subCategory2: 'authentication',
            pageType: 'customer account',
            attributes: {
              layerType: 'popin'
            },
            pageName: '/authentication/'
          };
          angularticsService.pageTrack(analyticsData);
        } else if (newVal === 'signup') {

          scope.route.signupModal = true;
          analyticsData = {
            pageID: 'NA',
            primaryCategory: 'customer account',
            subCategory1: 'authentication',
            subCategory2: 'sign-up',
            pageType: 'customer account',
            attributes: {
              layerType: 'popin'
            },
            pageName: '/sign-up/'
          };
          angularticsService.pageTrack(analyticsData);
        } else if (newVal === 'confirm') {

          scope.route.confirmModal = true;
          analyticsData = {
            pageID: 'NA',
            primaryCategory: 'customer account',
            subCategory1: 'sign-up',
            subCategory2: 'sign-up-success',
            pageType: 'customer account',
            attributes: {
              layerType: 'popin'
            },
            pageName: '/sign-up-success/'
          };
          angularticsService.pageTrack(analyticsData);
        } else {

          // nnModalsService.showModal('login', 123)
        }
      });

      scope.$watch('route', function(newVal) {

        if (newVal.loginModal === true) {

          scope.route.signupModal = false;
          scope.route.confirmModal = false;
          nnModalsService.showModal('login', 3456)
        }
        if (newVal.signupModal === true) {

          scope.route.loginModal = false;
          scope.route.confirmModal = false;
          nnModalsService.showModal('signup')
        }
        if (newVal.confirmModal === true) {

          scope.route.signupModal = false;
          scope.route.loginModal = false;
          nnModalsService.showModal('confirm')
        }
      }, true);

      if ($sessionStorage) {

        try {

          $sessionStorage.Nowness.userOptions = scope.userOptions;
        } catch (e) {

          void 0;
        }
      }

      scope.$on('$destroy', function() {

        $rootScope.remindMe = false;
        $rootScope.toBeLoved = false;
        $rootScope.playlistToBeLoved = false;
        $rootScope.categoryToBeFollowed = false;
        $rootScope.seriesToBeFollowed = false;

        Object.keys(rootWatchers)
          .forEach(function(killWatcherKey) {

            rootWatchers[killWatcherKey]();
          });
      });
    }
  };
}

export default LoginModalDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-login-modal/nn-login-modal.directive.js